module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, _vm._l((_vm.signatures), function(s) {
    return _c('div', {
      staticClass: "signature"
    }, [_c('div', {
      staticClass: "user-icon"
    }, [(s.isDonation) ? _c('img', {
      attrs: {
        "src": _vm.donationIcon
      }
    }) : _vm._e(), _vm._v(" "), (!s.isDonation) ? _c('img', {
      attrs: {
        "src": _vm.petitionIcon
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "user-name"
    }, [(_vm.hasName(s)) ? _c('div', {
      staticClass: "signature-name"
    }, [_vm._v("\n        " + _vm._s(_vm.limitSize(s.firstName)) + " " + _vm._s(_vm.limitSize(s.lastName)) + "\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.hasName(s)) ? _c('div', {
      staticClass: "signature-name"
    }, [_vm._v("Someone")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "signature-time"
    }, [(_vm.signature) ? _c('div', [_vm._v(_vm._s(_vm.signature))]) : _c('div', [_vm._v("planted a " + _vm._s(s.isDonation ? "forest" : "tree"))]), _vm._v("\n        " + _vm._s(s.timeDifference) + "\n      ")])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c79e8696","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=4ecaiejb649!./~/string-replace-webpack-plugin/loader.js?id=vjos074u90o!./src/components/leaf-relief/LastSignatures.vue
// module id = 849
// module chunks = 0